// import reviewsLogoEsquireImg from 'assets/images/logo_esquire.png';
import aloeVeraJuiceImg from 'assets/images/productPages/ingredients/aloe-vera-juice.png';
import appleCider from 'assets/images/productPages/ingredients/apple_cider_vinegar.png';
import inuline from 'assets/images/productPages/ingredients/arginine.png';
import cornStarch from 'assets/images/productPages/ingredients/corn-starch.png';
import riceWater from 'assets/images/productPages/ingredients/fermented_rice_water.png';
import cornMaldtodextrine from 'assets/images/productPages/ingredients/maltodextrin.png';
import oatFlourImg from 'assets/images/productPages/ingredients/oat-flour.png';
import okra from 'assets/images/productPages/ingredients/okra.png';
import pea from 'assets/images/productPages/ingredients/pea-protein.png';
import quinoa from 'assets/images/productPages/ingredients/quinoa-extract.png';
import redAglae from 'assets/images/productPages/ingredients/red-algae.png';
import sunflowerSeeds from 'assets/images/productPages/ingredients/sunflower-seeds.png';
import stylingGelFormulaModuleHero from 'assets/images/productPages/sg_module_2_hero.jpg';
import stylingGelCleanModuleHero from 'assets/images/productPages/sg_module_4_hero.jpg';
import stylingGelBgPicture from 'assets/images/productPages/styling_gel_carousel_1.jpg';
import stylingGelBgLabelledPicture from 'assets/images/productPages/styling_gel_carousel_2.jpg';
import stylingGelCarouselPaste from 'assets/images/productPages/styling_gel_carousel_3.jpg';
import stylingGelCarouselWater from 'assets/images/productPages/styling_gel_carousel_4.jpg';

export default {
  sampleFormulasSlider: [
    {
      title: 'Formula No. 750031 for Yaele',
      ingredients: [
        {
          image: oatFlourImg,
          name: 'Oat Protein',
          benefit: 'Deep Moisture',
        },
        {
          image: cornMaldtodextrine,
          name: 'Corn Maltodextrine',
          benefit: 'Strong Touchable Hold',
        },
        {
          image: riceWater,
          name: 'Fermented Rice Water',
          benefit: 'Hair Strength',
        },
        {
          image: pea,
          name: 'Pea Protein',
          benefit: 'Heat Protection',
        },
        {
          image: redAglae,
          name: 'Red Aglae',
          benefit: 'Anti-Pollution',
        },
        {
          image: okra,
          name: 'Okra',
          benefit: 'Coil Definition',
        },
      ],
    },
    {
      title: 'Formula No. 291745 for Alexis',
      ingredients: [
        {
          image: cornMaldtodextrine,
          name: 'Corn Maltodextrine',
          benefit: 'Medium Touchable Hold',
        },
        {
          image: riceWater,
          name: 'Fermented Rice Water',
          benefit: 'Frizz Control',
        },
        {
          image: pea,
          name: 'Pea Protein',
          benefit: 'Strenghtening',
        },
        {
          image: aloeVeraJuiceImg,
          name: 'Aloe Vera',
          benefit: 'Hydration',
        },
        {
          image: inuline,
          name: 'Inuline',
          benefit: 'Smoothing',
        },
        {
          image: redAglae,
          name: 'Sea Moss',
          benefit: 'Curl Definition',
        },
      ],
    },
    {
      title: 'Formula No. 658760 for Emily',
      ingredients: [
        {
          image: redAglae,
          name: 'Sea Moss',
          benefit: 'Coil Definition',
        },
        {
          image: appleCider,
          name: 'Apple Cider Vinegar',
          benefit: 'Shine',
        },
        {
          image: redAglae,
          name: 'Red Algae',
          benefit: 'Moisture Retention',
        },
        {
          image: cornStarch,
          name: 'Corn Starch',
          benefit: 'Frizz Control',
        },
        {
          image: quinoa,
          name: 'Quinoa',
          benefit: 'Heat Protection',
        },
        {
          image: sunflowerSeeds,
          name: 'Sunflower Seed',
          benefit: 'Antioxidant',
        },
      ],
    },
  ],
  proTips: [
    {
      background: 'blueLight',
      number: '316',
      description:
        'To refresh curls or slicked back styles, mist hair with water, section by section, before applying gel.',
    },
    {
      background: 'blueLight',
      number: '586',
      description:
        'In need of a haircut? As the last step of your daily styling routine, apply a bit of styling gel on the ends of curls or coils to help protect fragile split ends until your next trim. The gel will smooth hair fibers and create a barrier that helps to protect against future splitting.',
    },
    {
      background: 'blueLight',
      number: '701',
      description:
        'To add more shine and softness to  twists or braids, combine styling gel and curl cream in your palm and work the mixture through your hair.',
    },
  ],
  // Disable it until we have actual awards for styling gel
  // pressQuote: {
  //   image: reviewsLogoEsquireImg,
  //   source: 'Esquire Grooming Awards 2021',
  //   quote:
  //     'You can’t argue with a shampoo (and more) that’s customized to your hair, your environment, and even your lifestyle. Fill out a short quiz and it shows up to your door a few days later.',
  // },
  faq: [
    {
      question: 'What hair textures does Prose Custom Styling Gel work for?',
      answer:
        'Prose Styling Gel is custom formulated for versatile styling on textures ranging from waves to coils (and everything in between). Personalized based on your preferences, it provides the right amount of hold without flakes or crunch.',
    },
    {
      question: 'How do I use Styling Gel?',
      answer:
        "Prose Styling Gel is versatile and can be used to create and maintain a variety of hairstyles. This includes, but isn't limited to: wash n'gos, slicked styles, braids, edges, and twists. For best results, we recommend applying it on wet hair.",
    },
    {
      question: 'Can I layer my gel with other styling products?',
      answer: (
        <>
          Yes! Prose Styling Gel fits seamlessly into your haircare routine. Layer it with other
          stylers such as Curl Cream or Leave-in Conditioner for extra shine, hold, and definition
          plus nourishment for your strands. You can learn more about how to layer different styling
          products <a href="https://prose.com/blog/loc-method-hair.php">here</a>.
        </>
      ),
    },
    {
      question: 'How much hold does Styling Gel provide?',
      answer:
        "Your Prose Styling Gel will be customized to provide the ideal level of hold for your hair based on the results of your consultation. And don't worry–it'll never flake or crunch!",
    },
    {
      question: "Why does Prose Styling Gel look different from other gels that I've used?",
      answer:
        "Prose Styling Gel is an innovative formula with natural ingredients that can cause variations in each batch. The product may look cloudy, but that's normal. The color has no impact on the formula's freshness, efficacy, or consistency.",
    },
    {
      question: 'What ingredients are NOT included in Prose Custom Styling Gel formulas?',
      answer:
        'Prose Custom Styling Gel is customized to your needs using clean, innovative ingredients to provide hold, care, and protection. It will always be made without the following: oil, silicone, alcohol, phthalates, GMOs, sulfates, parabens, phthalates, and mineral oil. Like all Prose products, the Styling Gel is cruelty-free.',
    },
  ],
  formulaModule: {
    header: "A formula that couldn't exist without you",
    description:
      'Your unique hair needs and goals are addressed with a curated selection of our ever-growing list of sustainable and natural active ingredients.',
    hero: {
      imageDesktop: stylingGelFormulaModuleHero,
      imageMobile: stylingGelFormulaModuleHero,
      alt: 'woman with creative hair style',
    },
  },
  cleanBeautyModule: {
    header: 'We believe in clean and responsible beauty.',
    description:
      'Every product we formulate is free of parabens, sulfates, phthalates, mineral oils, GMOs, and is always cruelty-free. ' +
      'Based on your preferences, we can make your formula vegan, silicone-free, or fragrance-free.',
    hero: {
      imageDesktop: stylingGelCleanModuleHero,
      imageMobile: stylingGelCleanModuleHero,
      alt: 'woman touching her hair style',
    },
    cta: 'View Our Full Ingredient List',
  },
  imageCarousel: [
    {
      image: stylingGelBgPicture,
      alt: 'styling gel product pot',
    },
    {
      image: stylingGelBgLabelledPicture,
      alt: 'styling gel product pot with white background',
    },
    {
      image: stylingGelCarouselPaste,
      alt: 'styling gel product paste texture',
    },
    {
      image: stylingGelCarouselWater,
      alt: 'styling gel in water with its ingredients',
    },
  ],
};
